import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {AppConstants} from '@app/shared/util/app-constants';
import {IconName} from '@fortawesome/fontawesome-common-types';

@Component({
  selector: 'app-single-letter-icon',
  templateUrl: './single-letter-icon.component.html',
  styleUrls: ['./single-letter-icon.component.scss'],
  standalone: false
})
export class SingleLetterIconComponent implements OnChanges {

  @Input() text: string;
  @Input() title: string;
  @Input() fixedWidth = true;
  @Input() backgroundIconName: IconName = 'circle';
  @Input() backgroundClass = 'text-secondary';
  @Input() textClass = 'text-white';
  @Input() noTextPlaceContent = '';
  @Input() fontSize = AppConstants.DEFAULT_COMMENT_LOGO_FONT_SIZE;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.text) {
      if (this.title == null) {
        this.title = this.text;
      }
    }
  }
}
